/**
 * Código admin para /ar/invitacion - entrada infinita (nunca se marca como reclamada).
 * Configurable por env para producción; por defecto AR_ADMIN para desarrollo.
 */
const DEFAULT_AR_INVITACION_ADMIN_CODE = "AR_ADMIN";

export function getArInvitacionAdminCode(): string {
  const env = import.meta.env.VITE_AR_INVITACION_ADMIN_CODE as string | undefined;
  return (env && env.trim()) ? env.trim().toUpperCase() : DEFAULT_AR_INVITACION_ADMIN_CODE;
}
